<template>
  <form
    ref="form"
    data-url="/organizations/evaluationData"
    class="mb-0 mt-4"
    :class="{ 'loading-opacity': preloader }"
  >
    <fieldset class="form-group">
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>Datos de la Evaluación</h5>
        </legend>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Lugar de la evaluación</label>
            <app-input
              type="select"
              v-model="inputs.evaluation_place_id"
              :required="true"
              :list="evaluationPlaceList"
              placeholder="Ingrese el lugar de la evaluación"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Fecha(s) propuesta(s) para la(s) evaluación(es)</label>
            <app-input
              type="date"
              v-model="inputs.evaluation_date"
              :required="true"
              :placeholder="$t('select_valid_date')"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Estatus legal del laboratorio (tipo de empresa)</label>
            <app-input type="text" v-model="a" :disabled="true" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Propietario del Laboratorio de ensayos</label>
            <app-input type="text" v-model="b" :disabled="true" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Dirección del propietario</label>
            <app-input type="textarea" v-model="c" :disabled="true" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Tipo de Entidad</label>
            <app-input
              type="select"
              v-model="inputs.entity_type_id"
              :required="true"
              :list="entityTypeList"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>El Laboratorio realiza ensayos para</label>
            <app-input
              type="select"
              v-model="inputs.trials_entity_id"
              :required="true"
              :list="trialsEntityList"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset class="form-group">
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>Laboratorios con otras Acreditaciones</h5>
        </legend>

        <div class="col-12">
          <div class="form-group row align-items-center">
            <label class="col-10 pt-2">
              El laboratorio ya ha sido acreditado por un organismo de
              acreditación extranjero?
            </label>
            <app-input
              class="col-2"
              type="radio-buttons"
              :list="list"
              v-model="inputs.is_external_accredited"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12">
          <div class="form-group row align-items-center">
            <label class="col-10 pt-2">
              Tiene una solicitud para que la acreditación se realice por un
              organismo de acreditación extranjero?
            </label>
            <app-input
              class="col-2"
              type="radio-buttons"
              :list="list"
              v-model="inputs.has_external_accredited_application"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-sm-12" v-if="show">
          <div class="form-group">
            <label>Nombre del Organismo de Acreditación extranjero</label>
            <app-input
              type="text"
              v-model="inputs.external_accreditation_body"
              :required="true"
              placeholder="Ingrese el nombre del Organismo de Acreditación extranjero"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="show">
          <div class="form-group">
            <label>Fecha de la solicitud</label>
            <app-input
              type="date"
              v-model="inputs.application_date"
              :required="true"
              :placeholder="$t('select_valid_date')"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="show">
          <div class="form-group">
            <label>Fecha de la acreditación</label>
            <app-input
              type="date"
              v-model="inputs.evaluation_date"
              :required="true"
              :placeholder="$t('select_valid_date')"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="show">
          <div class="form-group">
            <label
              >Campos de ensayo para los cuales está acreditado o para los
              cuales la acreditación ha sido solicitada</label
            >
            <app-input
              type="textarea"
              v-model="inputs.test_fields"
              :required="true"
              placeholder="Ingrese los campos de ensayo para los cuales está acreditado o para los
              cuales la acreditación ha sido solicitada"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="show">
          <div class="form-group">
            <label
              >Certificaciones, aprobaciones y otros reconocimientos del
              laboratorio de ensayo</label
            >
            <app-input
              type="textarea"
              v-model="inputs.recognitions"
              :required="true"
              placeholder="Ingrese las certificaciones, aprobaciones y otros reconocimientos del
              laboratorio de ensayo"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </fieldset>

    <div class="row" v-if="!disabled">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        evaluation_place_id: null,
        evaluation_date: new Date(),
        entity_type_id: null,
        trials_entity_id: null,
        is_external_accredited: 0,
        has_external_accredited_application: 0,
        application_date: null,
        accreditation_date: null,
        test_fields: null,
        recognitions: null,
      },
      a: null,
      b: null,
      c: null,
      list: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },

  computed: {
    evaluationPlaceList() {
      return [
        { id: "", value: this.$t("select_option") },
        ...this.$store.state.accreditation.evaluationDataOptions
          .evaluationPlace,
      ];
    },
    entityTypeList() {
      return [
        { id: "", value: this.$t("select_option") },
        ...this.$store.state.accreditation.evaluationDataOptions.entityType,
      ];
    },
    trialsEntityList() {
      return [
        { id: "", value: this.$t("select_option") },
        ...this.$store.state.accreditation.evaluationDataOptions.trialsEntity,
      ];
    },
    show() {
      return (
        this.inputs.is_external_accredited ||
        this.inputs.has_external_accredited_application
      );
    },
    disabled() {
      return (
        this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status.code != "100"
      );
    },
  },

  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.inputs.accreditation_application_id = this.$store.state.accreditation.id;
      let d;
      if (this.inputs.evaluation_date != null) {
        d = this.inputs.evaluation_date;
        this.inputs.evaluation_date = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }
      if (this.show && this.inputs.application_date != null) {
        d = this.inputs.application_date;
        this.inputs.application_date = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }
      if (this.show && this.inputs.accreditation_date != null) {
        d = this.inputs.accreditation_date;
        this.inputs.accreditation_date = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = data;
      this.inputs.evaluation_date = new Date(data.evaluation_date);
      this.inputs.application_date =
        this.inputs.application_date != null
          ? new Date(data.application_date)
          : null;
      this.inputs.accreditation_date =
        this.inputs.accreditation_date != null
          ? new Date(data.accreditation_date)
          : null;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getEvaluationDataOptions");

      this.preloader = true;

      this.axiosGet(
        `${actions.ORGANIZATIONS_EVALUACTION_DATA}/${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = response.data;
            this.inputs.evaluation_date = new Date(this.inputs.evaluation_date);
            this.inputs.application_date =
              this.inputs.application_date != null
                ? new Date(this.inputs.application_date)
                : null;
            this.inputs.accreditation_date =
              this.inputs.accreditation_date != null
                ? new Date(this.inputs.accreditation_date)
                : null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
